import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SOFTWARE DETAIL TO EDIT ********************
export const fetchSoftwareDetails = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SOFTWARE_DETAIL_LOADING,
			payload: true
		});

		const response = await services.get(`/device/software/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SOFTWARE_DETAIL_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SOFTWARE_DETAIL_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
